import { createPopper } from '@popperjs/core'

const PLACEMENT = [
  'auto',
  'auto-start',
  'auto-end',
  'top',
  'top-start',
  'top-end',
  'bottom',
  'bottom-start',
  'bottom-end',
  'right',
  'right-start',
  'right-end',
  'left',
  'left-start',
  'left-end'
]

export default {
  props: {
    placement: {
      type: String,
      default: 'bottom',
      validator(value) {
        return ~PLACEMENT.indexOf(value)
      }
    },
    strategy: {
      type: String,
      default: 'absolute'
    },
    delay: {
      type: Number,
      default: 200
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    modifiers: {
      type: Array,
      default: () => [
        {
          name: 'offset',
          options: {
            offset: [0, 8]
          }
        },
        {
          name: 'arrow',
          options: {
            padding: 8
          }
        }
      ]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    showPopper() {
      return !this.disabled && this.visible
    }
  },
  watch: {
    showPopper(value) {
      if (value) this.updatePopper()
    }
  },
  methods: {
    createPopper() {
      const { placement, modifiers, strategy } = this
      const options = {}

      if (!/^(top|bottom|left|right)(-start|-end)?$/g.test(placement)) throw new Error('placement is not allowed')

      options.strategy = strategy
      options.placement = placement
      options.modifiers = modifiers

      const reference = (this.referenceElm = this.referenceElm || this.$refs.reference)
      const popper = (this.popperElm = this.popperElm || this.$refs.popper)

      this.popperJS = createPopper(reference, popper, options)

      if (this.appendToBody) {
        document.body.appendChild(popper)
      } else {
        this.$el.appendChild(popper)
      }
    },
    updatePopper() {
      if (this.popperJS) {
        this.popperJS.update()
      } else {
        this.createPopper()
      }
    },
    destroyPopper() {
      if (!this.popperJS) return
      this.popperJS.destroy()
      this.popperJS = null
    }
  },
  beforeDestroy() {
    this.destroyPopper()
    if (this.popperElm && this.popperElm.parentNode === document.body) document.body.removeChild(this.popperElm)
  }
}
